export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.5 24.5c0-9.94 8.06-18 18-18s18 8.06 18 18-8.06 18-18 18-18-8.06-18-18zm4 0c0 7.72 6.28 14 14 14s14-6.28 14-14-6.28-14-14-14-14 6.28-14 14zm14-2.82l4.58-4.6 2.84 2.84-4.6 4.58 4.6 4.58-2.84 2.84-4.58-4.58-4.58 4.58-2.84-2.84 4.6-4.58-4.6-4.58 2.84-2.84 4.58 4.6z\" fill=\"#CC0023\"/>",
  "attrs": {
    "width": "49",
    "height": "49",
    "viewBox": "0 0 49 49",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};